import { __exports as canvas } from "./index214.js";
import { __require as requireMerge } from "./index114.js";
import { __require as requireShared } from "./index215.js";
var hasRequiredCanvas;
function requireCanvas() {
  if (hasRequiredCanvas) return canvas;
  hasRequiredCanvas = 1;
  Object.defineProperty(canvas, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  var _shared = requireShared();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var CanvasRenderer = (function() {
    function CanvasRenderer2(canvas2, encodings, options) {
      _classCallCheck(this, CanvasRenderer2);
      this.canvas = canvas2;
      this.encodings = encodings;
      this.options = options;
    }
    _createClass(CanvasRenderer2, [{
      key: "render",
      value: function render() {
        if (!this.canvas.getContext) {
          throw new Error("The browser does not support canvas.");
        }
        this.prepareCanvas();
        for (var i = 0; i < this.encodings.length; i++) {
          var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);
          this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
          this.drawCanvasText(encodingOptions, this.encodings[i]);
          this.moveCanvasDrawing(this.encodings[i]);
        }
        this.restoreCanvas();
      }
    }, {
      key: "prepareCanvas",
      value: function prepareCanvas() {
        var ctx = this.canvas.getContext("2d");
        ctx.save();
        (0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
        var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
        var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);
        this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;
        this.canvas.height = maxHeight;
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (this.options.background) {
          ctx.fillStyle = this.options.background;
          ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
        ctx.translate(this.options.marginLeft, 0);
      }
    }, {
      key: "drawCanvasBarcode",
      value: function drawCanvasBarcode(options, encoding) {
        var ctx = this.canvas.getContext("2d");
        var binary = encoding.data;
        var yFrom;
        if (options.textPosition == "top") {
          yFrom = options.marginTop + options.fontSize + options.textMargin;
        } else {
          yFrom = options.marginTop;
        }
        ctx.fillStyle = options.lineColor;
        for (var b = 0; b < binary.length; b++) {
          var x = b * options.width + encoding.barcodePadding;
          if (binary[b] === "1") {
            ctx.fillRect(x, yFrom, options.width, options.height);
          } else if (binary[b]) {
            ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
          }
        }
      }
    }, {
      key: "drawCanvasText",
      value: function drawCanvasText(options, encoding) {
        var ctx = this.canvas.getContext("2d");
        var font = options.fontOptions + " " + options.fontSize + "px " + options.font;
        if (options.displayValue) {
          var x, y;
          if (options.textPosition == "top") {
            y = options.marginTop + options.fontSize - options.textMargin;
          } else {
            y = options.height + options.textMargin + options.marginTop + options.fontSize;
          }
          ctx.font = font;
          if (options.textAlign == "left" || encoding.barcodePadding > 0) {
            x = 0;
            ctx.textAlign = "left";
          } else if (options.textAlign == "right") {
            x = encoding.width - 1;
            ctx.textAlign = "right";
          } else {
            x = encoding.width / 2;
            ctx.textAlign = "center";
          }
          ctx.fillText(encoding.text, x, y);
        }
      }
    }, {
      key: "moveCanvasDrawing",
      value: function moveCanvasDrawing(encoding) {
        var ctx = this.canvas.getContext("2d");
        ctx.translate(encoding.width, 0);
      }
    }, {
      key: "restoreCanvas",
      value: function restoreCanvas() {
        var ctx = this.canvas.getContext("2d");
        ctx.restore();
      }
    }]);
    return CanvasRenderer2;
  })();
  canvas.default = CanvasRenderer;
  return canvas;
}
export {
  requireCanvas as __require
};
//# sourceMappingURL=index185.js.map
